import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFolderMinus = createIcon({
  displayName: 'IconFolderMinus',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 21H22V9H20V19H4V5H9.59L11.59 7H22V5H12.41L10.41 3H2V21ZM8 12H16V14H8V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
